import {
  ButtonGreenDeleteAccount,
  ButtonModelDeleteAccountUser,
  ButtonRedDeleteAccount,
  DeleteAccountUserContainer,
  DeleteAccountUserContainerModel,
  TitleModelDeleteAccountUser,
  TitleModelDeleteAccountUserQuestion,
} from "./ModelWindowAccount.styled";
import { toast, ToastContainer } from "react-toastify";
import { useAppDispatch } from "../../../../Redux/store";
import useAuth from "../../../../Redux/useAuth";
import { useNavigate } from "react-router-dom";
import { DeleteAccountUser } from "../../../../Redux/Auth/operations";
import { useLanguageContext } from "../../../../Components/Languages/Langs/LanguageContext";
import { DeleteAllTaskUser } from "../../../../Redux/tasks/operators";

interface SignInModelProps {
  onClose: () => void;
}

export const ModelWindowAccount: React.FC<SignInModelProps> = ({ onClose }) => {
  const { idUser } = useAuth();
  const { t } = useLanguageContext();
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const handleLogOut = async () => {
    toast.success("Account successfully delete!");
    try {
      dispatch(DeleteAccountUser({ id: idUser || "" }));
      dispatch(DeleteAllTaskUser({ userId: idUser || "" }));
      navigate("/");
    } catch (error: unknown) {
      toast.error(typeof error === "string" ? error : "Unexpected error");
    }
  };

  return (
    <>
      <DeleteAccountUserContainerModel>
        <DeleteAccountUserContainer>
          <TitleModelDeleteAccountUser>
            {t("privateTraslate.Models.DeleteAccountTitle")}
          </TitleModelDeleteAccountUser>
          <TitleModelDeleteAccountUserQuestion>
            {t("privateTraslate.Models.DeleteDataQuestion")}
          </TitleModelDeleteAccountUserQuestion>
          <ButtonModelDeleteAccountUser>
            <ButtonRedDeleteAccount onClick={handleLogOut}>
              {t("privateTraslate.Models.DeleteAccountTextYes")} 🥺
            </ButtonRedDeleteAccount>
            <ButtonGreenDeleteAccount onClick={onClose}>
              {t("privateTraslate.Models.DeleteAccountTextNo")} 🤩
            </ButtonGreenDeleteAccount>
          </ButtonModelDeleteAccountUser>
        </DeleteAccountUserContainer>
      </DeleteAccountUserContainerModel>
      <ToastContainer />
    </>
  );
};
